/**
 * @flow
 */
'use strict';

export const santeFamilialeCodes = [
{"code":"Glaucoma"},
{"code":"Cataract"},
{"code":"Dry AMD"},
{"code":"Wet AMD"},
{"code":"Heart"},
{"code":"Amblyopie"},
{"code":"Angles irido-cornéens étroits"},
{"code":"Anisométropie"},
{"code":"Anévrysme"},
{"code":"Astigmatisme"},
{"code":"Atrophie NO"},
{"code":"Aveugle"},
{"code":"Blepharoplastie"},
{"code":"Cancer thyroïde"},
{"code":"Cardiaque"},
{"code":"Cat frère (55ans)"},
{"code":"Cholesterol"},
{"code":"Coeur"},
{"code":"Cécité"},
{"code":"Cécité / diabete"},
{"code":"DB de type II"},
{"code":"Db type II"},
{"code":"Diabète"},
{"code":"Dystrophie Fuch"},
{"code":"Dystrophie cornée"},
{"code":"Dystrophie oculo pharyngée"},
{"code":"Déchirure rétine"},
{"code":"Décollement rétine"},
{"code":"Décollement rétine frère"},
{"code":"Décollement rétine?"},
{"code":"Détach. rét"},
{"code":"Emphysème"},
{"code":"Epilpsie"},
{"code":"Foie"},
{"code":"Fort astigm."},
{"code":"Forte hypermétropie"},
{"code":"Glaucome"},
{"code":"Glaucome ?"},
{"code":"Glaucome aigu"},
{"code":"Glaucome fermé"},
{"code":"Glaucome mère"},
{"code":"Glaucome père"},
{"code":"Glc "},
{"code":"Grande Rx (myopie)"},
{"code":"Greffe cornée"},
{"code":"Guttata"},
{"code":"HTA"},
{"code":"HTN, chol"},
{"code":"Hypercholesterol"},
{"code":"Hypermétropie"},
{"code":"Hypertonie oculaire"},
{"code":"Hypoplasie du NO"},
{"code":"Inconnue"},
{"code":"Injection"},
{"code":"Iridotomie"},
{"code":"Iridotomie probable"},
{"code":"Iris plateau"},
{"code":"MPOC"},
{"code":"Mal voyante"},
{"code":"Maladie chromosomiale"},
{"code":"Maladie de Crohn"},
{"code":"Maladie graves"},
{"code":"Maladie héréditaire "},
{"code":"Migraines"},
{"code":"Myasthenie grave"},
{"code":"Myopie"},
{"code":"Myopie progressive"},
{"code":"Myopie élevé"},
{"code":"Normal"},
{"code":"Nystagmus"},
{"code":"Névrite optique"},
{"code":"Occlusion vasculaire oculaire"},
{"code":"Osteoporose"},
{"code":"Prob. Cardiaques"},
{"code":"Probleme retine"},
{"code":"Retinite pigmentaire"},
{"code":"Retinopathie diabétique"},
{"code":"Rét. Pigmentaire"},
{"code":"SGF normal"},
{"code":"SOF normal"},
{"code":"Santé familiale 1"},
{"code":"Santé familiale 2"},
{"code":"Sclérose en plaques"},
{"code":"Secheresse"},
{"code":"Semi voyante"},
{"code":"Stargard"},
{"code":"Strab"},
{"code":"Strabisme"},
{"code":"Syndr dispersion pigm"},
{"code":"Syndrome sjogren"},
{"code":"Thalassemie"},
{"code":"Thyroïde"},
{"code":"Trauma"},
{"code":"Trou"},
{"code":"Trou maculaire"},
{"code":"Uveite chronique"},
{"code":"Vasculite"},
]
